// import React, { useState, useEffect } from 'react';
// import Sidebar from "../components/Sidebar";
// import Header from "../components/Header";
// import Popup from '../components/PopUP';

// const DesignHtml = () => {
//   const [popupMessage, setPopupMessage] = useState("Loading page content...");







//   return (
//     <>
//       <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
//       <Sidebar />
//       <div className="main-wrapper">
//         <Header />
//         <div className="content-wrapper">
//           <section className="main-section spacer-y">
//             <div className="container">
//               <div className="row gy-4">
//                 <div className="col-xl-12">
//                   <div className="common_main_bg_wrapper">
//                     <div className="common_main_heading_wrapper">
//                       <div className="vstack">
//                         <nav className="breadcrumb_nav">
//                             <ul className="breadcrumb mb-0">
//                                 <li className="breadcrumb-item"><a href="dashboard.html">Dashboard</a></li>
//                                 <li className="breadcrumb-item"><a href="#!">Quiz Management</a></li>
//                                 <li className="breadcrumb-item text-capitalize">Quiz</li>
//                             </ul>
//                         </nav>
//                         <h1 className='mb-2 mt-3'>Quiz</h1>
//                         <p className='text-white mb-1'>This is a description of the Quiz game, detailing its purpose and content for users.</p>
//                         <div className='hstack gap-2 gap-sm-4'>
//                           <span className='text-white'>Total Levels: 5</span>
//                           <span className='text-white'>Total Questions: 120</span>
//                         </div>
//                       </div>
//                       <div className="d-flex flex-end">
//                           <a href="#!" className="secondary_btn py-2 px-4">Back</a>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="common-table-wrapper mt-4">
//                     <div className="common-table-filter-wrapper">
//                       <div className="common-left-blk">
//                         <div className="common_sub_heading_wrapper mb-0">
//                           <h2>Levels</h2>
//                         </div>
//                       </div>
//                       <div className="common-right-blk">
//                         <div className="common-sort-blk">
//                           <div className="common-search-blk">
//                             <input type="search" className="form-control" id="search" placeholder="Search" />
//                           </div>
//                           <select name="" id="" className="form-select">
//                               <option value="Select Game"> Filter by Role:</option>
//                               <option value="All Game">Name</option>
//                               <option value="Quiz Game">Game</option>
//                           </select>
//                           <button className="secondary_btn py-2 fs-14">+  Add Questions to Level</button>
//                           <button className="secondary_btn py-2 fs-14">Export Level Data</button>
//                         </div>
//                       </div>
//                     </div>
//                     <div className='common_content_blk'>
//                       <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-4'>
//                         <div className='col'>
//                           <a href="#!" className='quiz_card_wrapper'>
//                             <div className='vstack align-items-center gap-3'>
//                               <div className='level_icon'>
//                                 <img src='assets/images/avio-placeholder.svg' alt="avioflAl" />
//                               </div>
//                               <div className='flex-grow-1'>
//                                 <h3 className='mb-1 text-center'>Troposphere</h3>                               
//                                 <p className='mb-0'><span> Level 1 - </span> Foundation</p>
//                               </div>
//                               <div>
//                                  <p className='fs-14 fw-semibold text-secondary text-center mb-0'>Approved - 12</p>
//                                 <p className='fs-14 fw-semibold text-secondary text-center mb-0'>Unapproved - 8</p>
//                               </div>
//                             </div>
//                           </a>
//                         </div>

//                         <div className='col'>
//                           <a href="#!" className='quiz_card_wrapper'>
//                             <div className='vstack align-items-center gap-3'>
//                               <div className='level_icon'>
//                                 <img src='assets/images/avio-placeholder.svg' alt="avioflAl" />
//                               </div>
//                               <div className='flex-grow-1'>
//                                 <h3 className='mb-1 text-center'>Stratosphere</h3>                               
//                                 <p className='mb-0'><span> Level 2 - </span> Intermediate</p>
//                               </div>
//                               <div>
//                                  <p className='fs-14 fw-semibold text-secondary text-center mb-0'>Approved - 12</p>
//                                 <p className='fs-14 fw-semibold text-secondary text-center mb-0'>Unapproved - 8</p>
//                               </div>
//                             </div>
//                           </a>
//                         </div>

//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DesignHtml;